import React, { useState, useEffect } from "react"
import {
  Table,
  Card,
  Button,
  Row,
  Col,
  Select,
  Spin,
  Form,
  Tag,
  Alert,
  Space,
  Input,
  Modal,
  Tooltip,
  DatePicker,
  Popconfirm,
} from "antd"
import Dropzone from "react-dropzone"
import Papa from "papaparse"
import moment from "moment-timezone"
import toastr from "toastr"
import * as Http from "utils/http.helper"
import { useLocation, useNavigate } from "react-router-dom"
import "toastr/build/toastr.min.css"
import dataStore from "utils/dataStore"
import {
  extractStyle,
  extractCategoryFromShipStations,
  extractSize,
  extractColor,
} from "utils/csvExtractors"
const allowedExtensions = ["csv"]
const css = `
.disabled-row { opacity:0.6; }
.empty_select_option .ant-select-selector { border: 1px solid red!important; background: #ff000054!important; }
.empty_select_option .ant-select-arrow { color: rgb(255 0 0)!important; }
.ant-form-item { margin-bottom:0!important; }
.custom_btn { background: #ffffff; color: #0958d9; border-color: #0958d9; box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02); border-style: dashed; }
`

const MultipleUploadFromShipStationCsv = () => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const maxDate = params.get("maxDate")

  // Temel state'ler
  const [file, setFile] = useState(null)
  const [data, setData] = useState([]) // Ayrıştırılmış siparişler
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [currentPage, setPage] = useState(1)
  const [notSaveList, setNotSaveList] = useState([])
  const [questionModal, setQuestionModal] = useState(false)
  const [fileName, setFileName] = useState(null)

  // Finansal listeler ve properties
  const [financialListApparel, setFinancialListApparel] = useState([])
  const [financialListEngraving, setFinancialListEngraving] = useState([])
  const [financialListPrint, setFinancialListPrint] = useState([])
  const [apparelProperties, setApparelProperties] = useState([])
  const [printProperties, setPrintProperties] = useState([])
  const [oldMultipleOrders, setOldMultipleOrders] = useState([])
  const [styleNameDict, setstyleNameDict] = useState({})
  const [allDataStore, setAllDataStore] = useState({})
  const [mainCategories, setMainCategories] = useState([
    {
      name: "Apparel",
    },
    {
      name: "Print",
    },
    {
      name: "Engraving",
    },
    {
      name: "Unknown",
    },
  ])

  // Dropdown seçenekleri
  const [options, setOptions] = useState(null) // Apparel için
  const [printOptions, setPrintOptions] = useState(null) // Print için
  const [printAparelOptions, setPrintAparelOptions] = useState([])

  const [availableDates, setAvailableDates] = useState([]) // CSV'den çıkarılan tarih listesi
  const [selectedDateRange, setSelectedDateRange] = useState([]) // Kullanıcının seçtiği aralık
  const [showDateModal, setShowDateModal] = useState(false) // Modal açık mı
  const [parsedOrdersRef, setParsedOrdersRef] = useState([])

  const [form] = Form.useForm()
  const [formV1] = Form.useForm()

  // Tablo kolonları (Category kolonu eklendi)
  const tableColumns = [
    { title: "SKU", dataIndex: "sku" },
    { title: "Order No", dataIndex: "orderId" },
    { title: "Quantity", dataIndex: "quantity" },
    // { title: "Item Name", dataIndex: "itemName", width: 300 },
    { title: "Personalization", dataIndex: "personalization" },
    { title: "Variations", dataIndex: "variant", width: 500 },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Style",
      dataIndex: "style",
      render: (_, row) =>
        row.category === "Engraving" ? (
          <span>{row.style}</span>
        ) : (
          <Form.Item className="style" name={[row.index, "style"]} label="">
            <Select
              className={row.style === "" ? "empty_select_option" : ""}
              onChange={(_, e) => handleChange(row, e, "style")}
              options={printAparelOptions}
              style={{ width: 150 }}
              placeholder="Style seçiniz."
              showSearch
              filterOption={(input, option) =>
                (option?.label || "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
        ),
    },
    {
      title: "Size",
      dataIndex: "size",
      render: (_, row) =>
        row.category === "Engraving" ? (
          <span></span>
        ) : (
          <Form.Item className="size" name={[row.index, "size"]} label="">
            <Select
              className={row.size === "" ? "empty_select_option" : ""}
              placeholder="Size seçiniz."
              onChange={(_, e) => handleChange(row, e, "size")}
              options={
                row.category === "Print"
                  ? getDropdownOptions(
                      "Print",
                      "sizes",
                      row.style,
                      printProperties,
                      printOptions?.sizes
                    )
                  : getDropdownOptions(
                      "Apparel",
                      "sizes",
                      row.style,
                      apparelProperties,
                      options?.sizes
                    )
              }
              style={{ width: 200 }}
              showSearch
              filterOption={(input, option) =>
                (option?.label || "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
        ),
    },
    {
      title: "Color",
      dataIndex: "color",
      render: (_, row) =>
        row.category === "Engraving" ? (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {row.color && (
              <Tooltip placement="top" title={row.color}>
                <span
                  style={{
                    width: 24,
                    height: 24,
                    backgroundColor: row.color,
                    border: "1px solid #ccc",
                    borderRadius: 3,
                    display: "inline-block",
                  }}
                />
              </Tooltip>
            )}
          </span>
        ) : (
          <Form.Item className="color" name={[row.index, "color"]}>
            <Select
              className={
                row.color === "" &&
                (row.category === "Apparel" ||
                  (row.category === "Print" &&
                    printProperties?.find(
                      p => p.styleId === row.style && p.colors.length > 0
                    )))
                  ? "empty_select_option"
                  : ""
              }
              placeholder="Color seçiniz."
              onChange={(_, e) => handleChange(row, e, "color")}
              options={
                row.category === "Print"
                  ? getDropdownOptions(
                      "Print",
                      "colors",
                      row.style,
                      printProperties,
                      printOptions?.colors
                    )
                  : row.category === "Apparel"
                  ? getDropdownOptions(
                      "Apparel",
                      "colors",
                      row.style,
                      apparelProperties,
                      options?.colors
                    )
                  : []
              }
              style={{ width: 150 }}
              showSearch
              filterOption={(input, option) =>
                (option?.label || "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
        ),
    },
    {
      title: "Price",
      dataIndex: "price",
      width: 150,
      render: (_, row) => {
        if (row.price) {
          return row.price.toFixed(2) + " $"
        } else {
          return row.category === "Engraving" ? (
            ""
          ) : (
            <Tag color="red" style={{ width: "100%", textAlign: "center" }}>
              --
            </Tag>
          )
        }
      },
    },
    {
      title: "Sale Date",
      dataIndex: "saleDate",
      render: (_, row) => moment.utc(row.saleDate).format("DD.MM.YYYY"),
    },
    {
      title: "",
      dataIndex: "action",
      render: (_, row) => (
        <Popconfirm
          title="Satırı silmek istiyor musunuz?"
          description="Bu satır tablodan kalıcı olarak çıkarılacak."
          onConfirm={() => handleDeleteRow(row.index)}
          okText="Evet"
          cancelText="Hayır"
        >
          <Button type="text" danger icon={<i className="bx bx-trash" />} />
        </Popconfirm>
      ),
    },
  ]

  useEffect(() => {
    if (parsedOrdersRef.length > 0 && selectedDateRange.length === 2) {
      filterBySelectedRange()
    }
  }, [parsedOrdersRef])

  // API çağrıları
  useEffect(() => {
    const categoryIds = [1, 3, 7]
    const categoryParams = categoryIds.map(id => `categoryIds=${id}`).join("&")
    Http.get(`api/orders/GetOldAddedMultipleOrders?${categoryParams}`)
      .then(res => {
        if (res?.success && res.data) setOldMultipleOrders(res.data)
      })
      .catch(() => {})
    Http.get(`api/orders/getproductspricesbycompany?categoryId=1`)
      .then(res => {
        if (res?.success && res.data) setFinancialListApparel(res.data)
      })
      .catch(() => {})
    // Apparel için
    Http.get(`api/orders/GetAllProperties`).then(res => {
      if (res.success && Array.isArray(res.data)) {
        const apparelStyles = {}
        const apparelColors = new Set()
        setApparelProperties(res.data)
        res.data.forEach(style => {
          apparelStyles[style.styleName.toLowerCase()] = style.styleName
          style.colors.forEach(color =>
            apparelColors.add(color.name.toLowerCase())
          )
        })

        setAllDataStore(prev => ({
          ...prev,
          apparelStyles,
          colors: [
            ...new Set([...(prev.colors || []), ...Array.from(apparelColors)]),
          ],
        }))
      }
    })
    Http.get(`api/orders/GetEngravingPricesByCompany`)
      .then(res => {
        if (res?.success && res.data) setFinancialListEngraving(res.data)
      })
      .catch(() => {})
    Http.get(`api/orders/getprintproductspricesbycompany?categoryId=7`)
      .then(res => {
        if (res?.success && res.data) setFinancialListPrint(res.data)
      })
      .catch(() => {})
    // Print için
    Http.get(`api/orders/GetAllPrintProperties`).then(res => {
      if (res.success && Array.isArray(res.data)) {
        const printStyles = {}
        const printColors = new Set()
        setPrintProperties(res.data)
        res.data.forEach(style => {
          printStyles[style.styleName.toLowerCase()] = style.styleName
          style.colors.forEach(color =>
            printColors.add(color.name.toLowerCase())
          )
        })

        setAllDataStore(prev => ({
          ...prev,
          printStyles,
          colors: [
            ...new Set([...(prev.colors || []), ...Array.from(printColors)]),
          ],
        }))
      }
    })
    // Dropdown seçenekleri
    getOptions()
    getPrintOptions()
  }, [])

  useEffect(() => {
    dataStore.colors = allDataStore.colors
    dataStore.apparelStyles = allDataStore.apparelStyles
    dataStore.printStyles = allDataStore.printStyles
  }, [allDataStore])

  // Yardımcı fonksiyon
  const toCamelCase = str =>
    str
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join("")

  // printOptions ve options geldiğinde dönüştür
  useEffect(() => {
    if (printOptions && options) {
      const printStyled = printOptions.styles.map(item => ({
        ...item,
        type: "Print",
        label: toCamelCase(item.label), // örn. roundneck -> Roundneck
      }))
      const apparelStyled = options.styles.map(item => ({
        ...item,
        type: "Apparel",
        label: toCamelCase(item.label),
      }))
      setPrintAparelOptions([...printStyled, ...apparelStyled])
    }
  }, [options, printOptions])

  // const getStyleNamesBySku = async skuList => {
  //   const payload = { skus: skuList }
  //   try {
  //     const res = await Http.post(
  //       `api/orders/GetApparelPrintStylesBySku`,
  //       payload
  //     )
  //     if (res?.success && res.data) {
  //       setstyleNameDict(res.data)
  //       return res.data
  //     } else {
  //       throw new Error("Invalid response")
  //     }
  //   } catch (error) {
  //     console.error("Error fetching styles:", error)
  //     throw error
  //   }
  // }

  /*
  Helper: parseVariationFromText
  Hem Item Name hem de Variations kolonlarından tespit yaparak uygun style, size, color ve personalization değerlerini döner.

  Apparel örneği: "SIZE:Comfort Colors L,COLOR:Grey" => { style: "comfort colors", size:"l", color:"grey", personalization:"" }
  Print örneği: "Size Options:Large 24x36 Inches" veya "Size:8x10,Frame:Only Print No Frame" => { style:"", size:"large 24x36 inches" veya "8x10", color:"", personalization:"" }
*/
  const parseVariationFromText = (
    itemName,
    variationStr = "",
    category,
    optionsData = {}
  ) => {
    // Boşsa hemen dön
    if (!variationStr && !itemName) {
      return { style: "", color: "", size: "", personalization: "" }
    }

    // 1️⃣ Hazırlık – metni normalize et
    const cleanVar = variationStr.replace(/\r?\n|\r/g, "").trim()
    const segments = cleanVar
      .split(/[,;]+/) // virgül veya noktalı virgül ile parçala
      .map(s => s.trim()) // baş/son boşluk sil
      .filter(Boolean)

    // 2️⃣ Anahtar–değer sözlüğü oluştur
    const kv = {}
    segments.forEach(seg => {
      const [key, ...rest] = seg.split(":")
      if (key && rest.length) {
        kv[key.trim().toLowerCase()] = rest.join(":").trim()
      }
    })

    // 3️⃣ Personalization – "Personalization:" görüldüyse kalan her şeyi al
    let personalizationText = ""
    const persIndex = cleanVar.toLowerCase().indexOf("personalization:")
    if (persIndex >= 0) {
      personalizationText = cleanVar
        .slice(persIndex + "personalization:".length)
        .trim()
    }

    // 4️⃣ Size / Color / Style sezgisi
    let textSize = ""
    let textColor = ""
    let textStyle = ""

    // ➡️ Kategoriye göre özel kurallar
    if (category === "Print") {
      // Tek ifadeyle hem "Size:" hem "Size Options:"
      textSize = kv["size"] || kv["size options"] || ""
      // Jewelry Dish Shape fallback
      if (!textSize && kv["jewelry dish shape"]) {
        textSize = kv["jewelry dish shape"]
      }
    } else if (category === "Apparel") {
      // 'size' içinde hem stil hem beden gelebilir → "Unisex-L" gibi
      const rawSize = kv["size"] || ""
      if (rawSize) {
        const parts = rawSize.split("-")
        if (parts.length === 2) {
          textStyle = parts[0].trim()
          textSize = parts[1].trim()
        } else {
          const tokens = rawSize.split(" ")
          textSize = tokens.pop().trim()
          textStyle = tokens.join(" ").trim()
        }
      }
      // Color veya Color option
      textColor = kv["color"] || kv["color option"] || ""
    }

    // 5️⃣ Opsiyon verilerinden eksik alanları tamamlama
    const lowerName = (itemName || "").toLowerCase()
    if (!textStyle && optionsData.styles) {
      const found = optionsData.styles.find(
        s =>
          cleanVar.toLowerCase().includes(s.label.toLowerCase()) ||
          lowerName.includes(s.label.toLowerCase())
      )
      if (found) textStyle = found.label
    }

    if (!textSize && optionsData.sizes) {
      const variationNorm = cleanVar
        .toLowerCase()
        .replace(/[\sx]+/g, "")
        .replace(/inches?|inch/gi, "")
      for (const sz of optionsData.sizes) {
        const labelNorm = sz.label
          .toLowerCase()
          .replace(/[\sx]+/g, "")
          .replace(/inches?|inch/gi, "")
        if (variationNorm.includes(labelNorm)) {
          textSize = sz.label
          break
        }
      }
    }

    // 6️⃣ Etiket objelerini bul
    const styleObj =
      optionsData.styles?.find(
        x => x.label.toLowerCase() === textStyle.toLowerCase()
      ) || null
    const sizeObj =
      optionsData.sizes?.find(
        x => x.label.toLowerCase() === textSize.toLowerCase()
      ) || null
    const colorObj =
      optionsData.colors?.find(
        x => x.label.toLowerCase() === textColor.toLowerCase()
      ) || null

    // 7️⃣ Sonuç
    return {
      style: styleObj?.value || "",
      size: sizeObj?.value || "",
      color: colorObj?.value || "",
      personalization: personalizationText,
    }
  }

  const saveButtonDisableCheck = data => {
    if (data.length === 0) return true
    const hasInvalidItem = data.some(x => {
      if (x.category === "Apparel") {
        return !x.style || !x.size || !x.color || !x.price
      } else if (
        x.category === "Print" &&
        printProperties?.find(p => p.styleId === x.style && p.colors.length > 0)
      ) {
        return !x.color
      } else {
        return !x.price
      }
    })
    return hasInvalidItem // true => disable button, false => enable
  }

  /*
  Helper: getDropdownOptions
  Belirli bir seçili style için ilgili property (Apparel veya Print) içinden size veya color seçeneklerini filtreleyip döner.
*/
  const getDropdownOptions = (
    category,
    type,
    selectedStyle,
    properties,
    defaultOptions
  ) => {
    const prop = properties.find(x => x.styleId === selectedStyle)
    if (prop) {
      if (type === "sizes")
        return prop.sizes.map(s => ({ label: s.name, value: s.id }))
      if (type === "colors")
        return prop.colors.map(c => ({
          label: c.name,
          value: c.id,
          hexCode: c.hexCode,
        }))
    }
    return defaultOptions
  }
  const getOptions = () => {
    setLoading(true)
    Http.get(`api/orders/GetAllProperties`)
      .then(res => {
        if (res?.success && Array.isArray(res.data)) {
          // Apparel için union dropdown seçenekleri
          const sizesUnion = []
          const colorsUnion = []
          const stylesUnion = []
          res.data.forEach(prop => {
            if (prop.sizes && Array.isArray(prop.sizes)) {
              prop.sizes.forEach(s => {
                if (!sizesUnion.find(item => item.value === s.id)) {
                  sizesUnion.push({ label: s.name.toLowerCase(), value: s.id })
                }
              })
            }
            if (prop.colors && Array.isArray(prop.colors)) {
              prop.colors.forEach(c => {
                if (!colorsUnion.find(item => item.value === c.id)) {
                  colorsUnion.push({
                    label: c.name.toLowerCase(),
                    value: c.id,
                    hexCode: c.hexCode,
                  })
                }
              })
            }
            if (prop.styleName) {
              if (!stylesUnion.find(item => item.value === prop.styleId)) {
                stylesUnion.push({
                  label: prop.styleName.toLowerCase(),
                  value: prop.styleId,
                })
              }
            }
          })

          setOptions({
            sizes: sizesUnion,
            colors: colorsUnion,
            styles: stylesUnion,
          })
        }
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        toastr.error(error?.response?.data?.Message || error.message)
      })
  }

  const handleCategoryChange = (index, value) => {
    const updatedData = [...data]
    updatedData[index].category = value

    if (value === "Engraving") {
      updatedData[index].style = ""
      updatedData[index].size = ""
      updatedData[index].color = ""
      updatedData[index].price = lookupPrice(
        "Engraving",
        {},
        updatedData[index]
      )
    } else {
      updatedData[index].style = ""
      updatedData[index].size = ""
      updatedData[index].color = ""
      updatedData[index].price = ""
    }

    setData(updatedData)
    form.setFieldsValue({ apparelList: updatedData })
  }

  const getPrintOptions = () => {
    setLoading(true)
    Http.get(`api/orders/GetAllPrintProperties`)
      .then(res => {
        if (res?.success && Array.isArray(res.data)) {
          const sizesUnion = []
          const colorsUnion = []
          const stylesUnion = []
          res.data.forEach(prop => {
            if (prop.sizes && Array.isArray(prop.sizes)) {
              prop.sizes.forEach(s => {
                if (!sizesUnion.find(item => item.value === s.id)) {
                  sizesUnion.push({ label: s.name.toLowerCase(), value: s.id })
                }
              })
            }
            if (prop.colors && Array.isArray(prop.colors)) {
              prop.colors.forEach(c => {
                if (!colorsUnion.find(item => item.value === c.id)) {
                  colorsUnion.push({
                    label: c.name.toLowerCase(),
                    value: c.id,
                    hexCode: c.hexCode,
                  })
                }
              })
            }
            if (prop.styleName) {
              if (!stylesUnion.find(item => item.value === prop.styleId)) {
                stylesUnion.push({
                  label: prop.styleName.toLowerCase(),
                  value: prop.styleId,
                })
              }
            }
          })
          setPrintOptions({
            sizes: sizesUnion,
            colors: colorsUnion,
            styles: stylesUnion,
          })
        }
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        toastr.error(error?.response?.data?.Message || error.message)
      })
  }

  // Dosya yükleme (Dropzone)
  const handleFileChange = files => {
    setPage(1)
    setLoading(true)
    setData([])
    setFile(null)
    setError("")
    if (files.length > 0) {
      const inputFile = files[0]
      const fileExtension = inputFile?.type.split("/")[1]
      if (!allowedExtensions.includes(fileExtension)) {
        setLoading(false)
        setError("Lütfen geçerli bir CSV dosyası yükleyiniz.")
        return
      }
      setFile(inputFile)
      setLoading(false)
    } else {
      setLoading(false)
      setError("Lütfen geçerli bir CSV dosyası yükleyiniz.")
    }
  }

  // Tarih kontrolü
  const isFutureDate = dateString => {
    console.log(maxDate, "maxDate4444")
    const today = maxDate !== "null" ? new Date(maxDate) : new Date()
    if (maxDate === "null") today.setHours(0, 0, 0, 0)
    const [day, month, year] = dateString.split(".").map(Number)
    const date = new Date(year, month - 1, day)
    return date >= today
  }

  // Kategori belirleme:
  // 1. Eğer SKU financialListEngraving'de eşleşiyorsa "Engraving"
  // 2. Aksi halde, Item Name veya Variations içinde, ilgili API'den gelen property (apparelProperties veya printProperties) içindeki styleName ile eşleşiyorsa "Apparel" veya "Print"
  const determineCategory = item => {
    const sku = item["OrderItemSku"]?.toLowerCase() || ""
    if (financialListEngraving.some(prod => prod.sku?.toLowerCase() === sku))
      return "Engraving"

    const itemName = item["OrderItemDescription"]?.toLowerCase() || ""
    const variations = item["OrderItemOptions"]?.toLowerCase() || ""

    const apparelKeywords = ["shirt", "hoodie", "sweatshirt", "t-shirt", "tee"]
    const printKeywords = ["frame", "canvas", "sign", "print", "mug", "dish"]

    const isApparel =
      apparelProperties.some(
        prop =>
          prop.styleName &&
          (itemName.includes(prop.styleName.toLowerCase()) ||
            variations.includes(prop.styleName.toLowerCase()))
      ) ||
      apparelKeywords.some(
        keyword => itemName.includes(keyword) || variations.includes(keyword)
      )

    const isPrint =
      printProperties.some(
        prop =>
          prop.styleName &&
          (itemName.includes(prop.styleName.toLowerCase()) ||
            variations.includes(prop.styleName.toLowerCase()) ||
            variations.includes("frame") ||
            variations.includes("Frame"))
      ) ||
      printKeywords.some(
        keyword => itemName.includes(keyword) || variations.includes(keyword)
      ) ||
      variations.includes("frame") ||
      variations.includes("Frame")

    if (isApparel && !isPrint) return "Apparel"
    if (isPrint && !isApparel) return "Print"
    if (isApparel && isPrint) return "Apparel" // Conflict durumunda Apparel öncelikli

    return "Unknown"
  }

  // Yeni helper: getPreselectedValues
  // Hem Item Name hem de Variations üzerinden tespit yaparak, mevcut dropdown seçenekleriyle eşleşen değerleri döner.
  const getPreselectedValues = (itemName, variationStr, category) => {
    const currentOptions = category === "Print" ? printOptions : options
    return parseVariationFromText(
      itemName,
      variationStr,
      category,
      currentOptions
    )
  }

  // Fiyat lookup fonksiyonu
  // Apparel: önce color varsa (style, size, color), yoksa sadece style & size,
  // Print: önce color varsa (style, size, color), yoksa style & size,
  // Engraving: SKU eşleşmesi.
  const lookupPrice = (category, parsedVariations, order) => {
    if (category === "Apparel") {
      if (parsedVariations.style && parsedVariations.size) {
        let priceObj = null
        if (parsedVariations.color) {
          priceObj = financialListApparel.find(
            x =>
              x.styleId === parsedVariations.style &&
              x.sizeId === parsedVariations.size &&
              x.colorId === parsedVariations.color
          )
        }
        if (!priceObj) {
          priceObj = financialListApparel.find(
            x =>
              x.styleId === parsedVariations.style &&
              x.sizeId === parsedVariations.size
          )
        }
        return priceObj ? priceObj.price : ""
      }
    } else if (category === "Print") {
      if (parsedVariations.style && parsedVariations.size) {
        let priceObj = null
        if (parsedVariations.color) {
          priceObj = financialListPrint.find(
            x =>
              x.styleId === parsedVariations.style &&
              x.sizeId === parsedVariations.size &&
              x.colorId === parsedVariations.color
          )
        }
        if (!priceObj) {
          priceObj = financialListPrint.find(
            x =>
              x.styleId === parsedVariations.style &&
              x.sizeId === parsedVariations.size
          )
        }
        return priceObj ? priceObj.price : ""
      }
    } else if (category === "Engraving") {
      const sku = order["OrderItemSku"]
        ? order["OrderItemSku"].toLowerCase()
        : ""
      const priceObj = financialListEngraving.find(
        x => x.sku && x.sku.toLowerCase() === sku
      )
      return priceObj ? priceObj.price : ""
    }
    return ""
  }

  const filterBySelectedRange = () => {
    if (
      !selectedDateRange ||
      selectedDateRange.length !== 2 ||
      !selectedDateRange[0] ||
      !selectedDateRange[1]
    ) {
      toastr.error("Lütfen geçerli bir tarih aralığı seçiniz.")
      return
    }

    const [start, end] = selectedDateRange
    const startUtc = moment.utc(start.format("YYYY-MM-DD"))
    const endUtc = moment.utc(end.format("YYYY-MM-DD"))

    const filtered = parsedOrdersRef.filter(item => {
      const d = moment.utc(item.saleDate)
      return d.isSameOrAfter(startUtc, "day") && d.isSameOrBefore(endUtc, "day")
    })
    if (filtered.length === 0) {
      toastr.warning("Bu tarih aralığında sipariş bulunamadı.")
      setData([])
      form.setFieldsValue({ apparelList: [] })
      return
    }

    const isIncomplete = row => {
      if (row.category === "Apparel")
        return !row.style || !row.size || !row.color || !row.price
      if (row.category === "Print") {
        const requiresColor = printProperties?.find(
          p => p.styleId === row.style && p.colors.length > 0
        )
        return (
          !row.style || !row.size || (requiresColor && !row.color) || !row.price
        )
      }
      if (row.category === "Engraving") return !row.price
      return true
    }

    const finalSorted = [...filtered].sort((a, b) => {
      return (isIncomplete(a) ? -1 : 1) - (isIncomplete(b) ? -1 : 1)
    })

    finalSorted.forEach((item, i) => (item.index = i))
    setData(finalSorted)
    form.setFieldsValue({ apparelList: finalSorted })
  }

  // CSV ayrıştırma fonksiyonu
  const handleParse = async () => {
    setLoading(true)

    if (!file) {
      alert("Geçerli bir dosya yükleyiniz")
      setLoading(false)
      return
    }

    const reader = new FileReader()

    reader.onload = async ({ target }) => {
      const allSaleDates = new Set()
      const csv = Papa.parse(target.result, {
        header: true,
        skipEmptyLines: "greedy",
        newline: "",
        quoteChar: '"',
        escapeChar: '"',
      })

      const parsedData = csv?.data
      const parsedOrders = []
      const notSaveListTemp = []
      let control = true
      let dateProblem = true
      let i = 0
      try {
        parsedData.forEach(item => {
          const itemName = item["OrderItemDescription"] || ""
          const variations = item["OrderItemOptions"] || ""
          const rawStyle = extractStyle(itemName, variations) || ""
          const category =
            extractCategoryFromShipStations(
              rawStyle,
              item,
              financialListEngraving
            ) || ""
          const rawSize = extractSize(itemName, variations, rawStyle) || ""
          const rawColor = extractColor(itemName, variations, itemName) || ""

          const opts = category === "Print" ? printOptions : options

          const styleOpt = opts?.styles?.find(
            o => o.label.toLowerCase() === rawStyle.toLowerCase()
          )
          const styleId = styleOpt ? styleOpt.value : ""

          const sizeOpt = opts?.sizes?.find(
            o => o.label.toLowerCase() === rawSize.toLowerCase()
          )
          const sizeId = sizeOpt ? sizeOpt.value : ""

          const colorOpt = opts?.colors?.find(
            o => o.label.toLowerCase() === rawColor.toLowerCase()
          )
          const colorId = colorOpt ? colorOpt.value : ""

          // ✅ Yeni ek: style'a ait olmayan size veya color varsa boş bırak
          let validatedSizeId = ""
          let validatedColorId = ""

          const propList =
            category === "Print" ? printProperties : apparelProperties
          const matchedProp = propList.find(p => p.styleId === styleId)

          if (matchedProp) {
            if (sizeId && matchedProp.sizes.some(s => s.id === sizeId)) {
              validatedSizeId = sizeId
            }
            if (colorId && matchedProp.colors.some(c => c.id === colorId)) {
              validatedColorId = colorId
            }
          }

          const price = lookupPrice(
            category,
            { style: styleId, size: sizeId, color: colorId },
            item
          )

          const variationStr = item["OrderItemOptions"] || ""
          const personalizationMatch = variationStr.match(
            /personalization\s*:\s*([\s\S]*?)(?=,\s*\w+\s*:|$)/i
          )
          const personalization = personalizationMatch
            ? personalizationMatch[1].trim()
            : ""

          const today = new Date()
          const yearStart = today.getFullYear().toString().slice(0, 2)

          // Saat kısmını at, sadece tarih kısmını al
          const dateParts = item["OrderDate"]?.split(" ")[0]?.split("/")

          if (dateParts?.length === 3) {
            const yearStart = new Date().getFullYear().toString().slice(0, 2)
            const csvYear =
              dateParts[2].length === 4
                ? dateParts[2]
                : yearStart + dateParts[2]
            const csvMonth = dateParts[0].padStart(2, "0")
            const csvDay = dateParts[1].padStart(2, "0")
            const formatted = `${csvDay}.${csvMonth}.${csvYear}`
            allSaleDates.add(formatted)
          }

          if (dateParts?.length < 3) return

          const csvYear =
            dateParts[2].length === 4 ? dateParts[2] : yearStart + dateParts[2]
          const csvMonth = dateParts[0]
          const csvDay = dateParts[1]
          const newDate = `${csvDay}.${csvMonth}.${csvYear}`

          if (!oldMultipleOrders.includes(item["OrderNumber"])) {
            if (
              item["OrderItemSku"] &&
              item["OrderDate"] &&
              item["OrderNumber"]
            ) {
              parsedOrders.push({
                index: i,
                sku: item["OrderItemSku"],
                saleDate:
                  moment(item["OrderDate"], "M/DD/YYYY hh:mm A").format(
                    "YYYY-MM-DD"
                  ) + "T00:00:00.000Z",
                itemName: item["OrderItemDescription"],
                quantity: item["OrderItemQuantity"],
                transactionId: item["OrderItemExternalID"],
                variant: item["OrderItemOptions"],
                orderId: item["OrderNumber"],
                shipmentOrder: {
                  nameSurname: item["OrderShipName"],
                  city: item["OrderShipCity"],
                  addressLine1: item["OrderShipStreet1"],
                  addressLine2: item["OrderShipStreet2"],
                  zipCode: item["OrderShipPostalCode"],
                  stateCode: item["OrderShipState"],
                  country: item["OrderShipCountryCode"],
                },
                category,
                style: styleId,
                size: validatedSizeId,
                color: validatedColorId,
                personalization,
                price,
              })
              i++
            } else {
              notSaveListTemp.push({
                index: i,
                sku: item["OrderItemSku"],
                saleDate:
                  moment(item["OrderDate"], "M/DD/YYYY hh:mm A").format(
                    "YYYY-MM-DD"
                  ) + "T00:00:00.000Z",
                itemName: item["OrderItemDescription"],
                quantity: item["OrderItemQuantity"],
                transactionId: item["OrderItemExternalID"],
                variant: item["OrderItemOptions"],
                orderId: item["OrderNumber"],
              })
            }
          } else if (control) {
            control = false
          }
        })
        const sortedDates = Array.from(allSaleDates).sort(
          (a, b) => moment(a, "DD.MM.YYYY") - moment(b, "DD.MM.YYYY")
        )
        setParsedOrdersRef([...parsedOrders])
        setAvailableDates(sortedDates)

        setLoading(false)
        return // Modal açıldığında parse'ı durdur
      } catch (err) {
        setLoading(false)
        return
      }

      // 🔎 Yardımcı fonksiyon: Gerçek eksiklik kontrolü
      const isIncomplete = row => {
        if (row.category === "Apparel") {
          return !row.style || !row.size || !row.color || !row.price
        }
        if (row.category === "Print") {
          const requiresColor = printProperties?.find(
            p => p.styleId === row.style && p.colors.length > 0
          )
          return (
            !row.style ||
            !row.size ||
            (requiresColor && !row.color) ||
            !row.price
          )
        }
        if (row.category === "Engraving") {
          return !row.price
        }
        return true
      }

      if (parsedOrders.length > 0) {
        if (!control) {
          toastr.info(
            "Daha önce kaydedilmiş order numaraları olan siparişler kaydedilmeyecektir."
          )
        }
        if (notSaveListTemp.length > 0) {
          setNotSaveList(notSaveListTemp)
        }

        // 🔄 Eksikler en üste gelecek şekilde sırala
        const finalSorted = [...parsedOrders].sort((a, b) => {
          return (isIncomplete(a) ? -1 : 1) - (isIncomplete(b) ? -1 : 1)
        })
        finalSorted.forEach((item, i) => (item.index = i))

        setData(finalSorted)
        form.setFieldsValue({ apparelList: finalSorted })
      } else {
        toastr.error(
          !dateProblem
            ? "Dosyadaki siparişlerin tarihi bugünden eski olduğu için kaydedilmeyecektir."
            : !control
            ? "Dosyadaki siparişlerden bazıları daha önce kaydedilmiştir."
            : "Beklenmedik bir hata! IT birimiyle iletişime geçiniz."
        )
      }

      setLoading(false)
    }

    reader.readAsText(file)
  }

  // Siparişleri kaydeden fonksiyon (örnek Apparel için API çağrısı)
  const handleSaveCsv = () => {
    // setQuestionModal(false)
    const recordName = moment().tz("America/Chicago").format("DD-MM-YYYY")
    // const recordName = "02-07-2025"
    const obj = { orders: [], recordName }
    setTimeout(() => {
      data.forEach(item => {
        obj.orders.push({
          sku: item.sku,
          saleDate: item.saleDate,
          itemName: item.itemName,
          quantity: item.quantity,
          transactionId: item.transactionId,
          variant: item.variant,
          orderId: item.orderId,
          categoryId:
            item.category === "Apparel"
              ? 1
              : item.category === "Engraving"
              ? 3
              : item.category === "Print"
              ? 7
              : null,
          sizeId: item.size && item.category !== "Engraving" ? item.size : null,
          styleId:
            item.style && item.category !== "Engraving" ? item.style : null,
          colorId:
            item.color && item.category !== "Engraving" ? item.color : null,
          price: item.price,
          personalization: item.personalization,
          shipmentOrder: item.shipmentOrder,
        })
      })
      Http.post("api/orders/CreateMultipleEngravingApparelOrders", obj)
        .then(res => {
          if (res.success) {
            toastr.success(
              "CSV dosyası başarıyla yüklendi. Kaydetme işlemi zaman alabilir."
            )
            setTimeout(() => {
              navigate("/multiple-order-list")
            }, 300)
            setLoading(false)
          } else {
            setLoading(false)
            toastr.error(res?.Message)
          }
        })
        .catch(error => {
          setLoading(false)
          toastr.error(error?.response?.data?.Message)
        })
    }, 300)
  }

  const handleDeleteRow = rowIndex => {
    const updated = data.filter(row => row.index !== rowIndex)

    // index'leri yeniden sırala (gerekirse)
    updated.forEach((row, i) => (row.index = i))

    setData(updated)
    form.setFieldsValue({ apparelList: updated })
  }

  useEffect(() => {
    form.setFieldsValue({ apparelList: data })
  }, [data])

  // Inline düzenleme için handleChange fonksiyonu
  // Apparel için: önce color varsa (style, size, color), yoksa style & size eşleşmesi aranır.
  // Print için: benzer şekilde, dropdown'lardan seçilen değerler üzerinden fiyat lookup yapılır.
  const handleChange = (row, value, type) => {
    setLoading(true)
    const updatedData = [...data] // yeni bir referans alınmalı!

    if (type === "style") {
      updatedData[row.index].category = value.type
      updatedData[row.index].style = value.value
      updatedData[row.index].size = ""
      updatedData[row.index].color = ""
      updatedData[row.index].price = "" // Fiyatı da sıfırlamak mantıklı olacaktır.

      // formu da güncelle
      form.setFields([
        { name: ["apparelList", row.index, "style"], value: value.value },
        { name: ["apparelList", row.index, "size"], value: "" },
        { name: ["apparelList", row.index, "color"], value: "" },
      ])

      setData(updatedData)
      setLoading(false)
      return
    }

    if (type === "size") {
      updatedData[row.index].size = value.value
    }

    if (type === "color") {
      updatedData[row.index].color = value.value
    }

    let sizesValue = updatedData[row.index]?.size
    let stylesValue = updatedData[row.index]?.style
    let colorValue = updatedData[row.index]?.color
    let finderPrice = null

    if (updatedData[row.index].category === "Apparel") {
      if (stylesValue && sizesValue) {
        finderPrice =
          financialListApparel.find(
            x =>
              x.styleId === stylesValue &&
              x.sizeId === sizesValue &&
              (colorValue ? x.colorId === colorValue : true)
          ) ||
          financialListApparel.find(
            x => x.styleId === stylesValue && x.sizeId === sizesValue
          )
      }
    } else if (updatedData[row.index].category === "Print") {
      if (stylesValue && sizesValue) {
        finderPrice =
          financialListPrint.find(
            x =>
              x.styleId === stylesValue &&
              x.sizeId === sizesValue &&
              (colorValue ? x.colorId === colorValue : true)
          ) ||
          financialListPrint.find(
            x => x.styleId === stylesValue && x.sizeId === sizesValue
          )
      }
    }

    updatedData[row.index].price = finderPrice?.price || ""

    // Formu güncelle
    form.setFieldsValue({ apparelList: updatedData })
    setData(updatedData)

    setTimeout(() => {
      setLoading(false)
    }, 100)
  }

  const processCsvRows = async combinedCsvRows => {
    setLoading(true)

    const parsedOrders = []
    const notSaveListTemp = []

    let i = 0
    for (let item of combinedCsvRows) {
      try {
        const itemName = item["OrderItemDescription"] || ""
        const variations = item["OrderItemOptions"] || ""
        const category = determineCategory(item)
        const { style, size, color, personalization } = getPreselectedValues(
          itemName,
          variations,
          category
        )

        const price = lookupPrice(category, { style, size, color }, item)

        const saleDate = item["OrderDate"]
        if (!saleDate || !item["OrderItemSku"] || !item["OrderNumber"]) {
          notSaveListTemp.push({ ...item, index: i })
          continue
        }

        const [month, day, year] = saleDate.split("/")
        const fullDate = `${day.padStart(2, "0")}.${month.padStart(2, "0")}.${
          year.length === 4 ? year : "20" + year
        }`

        if (!oldMultipleOrders.includes(item["OrderNumber"])) {
          if (
            item["OrderItemSku"] &&
            item["OrderDate"] &&
            item["OrderNumber"]
          ) {
            parsedOrders.push({
              index: i,
              sku: item["OrderItemSku"],
              saleDate:
                moment(saleDate, "M/DD/YYYY hh:mm A").format("YYYY-MM-DD") +
                "T00:00:00.000Z",
              itemName: item["OrderItemDescription"],
              quantity: item["OrderItemQuantity"],
              transactionId: item["OrderItemExternalID"],
              variant: item["OrderItemOptions"],
              orderId: item["OrderNumber"],
              shipmentOrder: {
                nameSurname: item["OrderShipName"],
                city: item["OrderShipCity"],
                addressLine1: item["OrderShipStreet1"],
                addressLine2: item["OrderShipStreet2"],
                zipCode: item["OrderShipPostalCode"],
                stateCode: item["OrderShipState"],
                country: item["OrderShipCountryCode"],
              },
              category,
              style,
              size,
              color,
              personalization,
              price,
            })
          }
        }
        i++
      } catch (err) {
        console.warn("Row parse error:", err)
      }
    }

    setParsedOrdersRef([...parsedOrders])
    filterBySelectedRange()
    setLoading(false)
  }

  const handleFilterData = () => {
    setLoading(true)
    setPage(1)
    const filter = data.filter(
      x => x.size === "" || x.style === "" || x.color === "" || !x.price
    )
    if (filter[0].index % 10 === 0) {
      setPage(Math.ceil(filter[0].index / 10 + 1))
      setLoading(false)
    } else {
      setPage(Math.ceil(filter[0].index / 10))
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content mb-3">
        <style>{css}</style>
        {/* {questionModal && (
          <Modal
            title="Dikkat"
            open={true}
            centered
            maskClosable={false}
            onOk={() => handleParse(true)}
            onCancel={() => handleParse(false)}
            okText="Yes"
            cancelText="No"
          >
            <p>
              İlk defa veri kaydediyorsunuz. Bu günden önceki kayıtlarınız
              kaydedilmeyecektir. Onaylıyor musunuz?
            </p>
          </Modal>
        )} */}
        <Spin spinning={loading}>
          <Modal
            title="Tarih Aralığı Seçiniz"
            open={showDateModal}
            onOk={async () => {
              await handleParse(false)

              setShowDateModal(false)
            }}
            onCancel={() => {
              setShowDateModal(false)
              setData([]) // vazgeçerse tabloyu boşalt
            }}
          >
            <p>
              Lütfen hangi tarih aralığındaki siparişleri görmek istediğinizi
              seçin.
            </p>
            <DatePicker.RangePicker
              format="DD.MM.YYYY"
              style={{ width: "100%" }}
              onChange={range => {
                setSelectedDateRange(range)
              }}
            />

          </Modal>
          {financialListApparel.length === 0 ? (
            <Alert
              message="Sistem Mesajı!"
              description="Apparel işlemleriniz için sistem admin tarafından size ait ürün baz fiyatı veya fiyatlarının belirlemesi gerekmektedir. İletişime geçiniz!"
              type="error"
            />
          ) : (
            <Card>
              <Row
                gutter={[16, 16]}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Col lg={6}>
                  <h4>Add Multiple Order from ShipStation CSV</h4>
                </Col>
                <Col
                  lg={18}
                  className="d-flex align-items-center justify-content-end gap-2 mb-3"
                >
                  <Button
                    type="button"
                    className="btn btn_default d-flex align-items-center justify-content-center"
                    onClick={() => {
                      navigate("/multiple-order-list")
                      setFileName(null)
                    }}
                    icon={
                      <i className="bx bx-arrow-back font-size-16 align-middle mr-2"></i>
                    }
                  >
                    Return to List
                  </Button>
                  {data.length > 0 && (
                    <Button
                      type="button"
                      className="btn btn_primary d-flex align-items-center justify-content-center"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setData([])
                        setPage(1)
                        setFileName(null)
                      }}
                      icon={
                        <i className="bx bx-cloud-upload font-size-16 align-middle mr-2"></i>
                      }
                    >
                      Tekrar CSV Yükle
                    </Button>
                  )}
                </Col>
                {data.find(
                  x =>
                    x.size === "" ||
                    x.style === "" ||
                    x.color === "" ||
                    x.price === "" ||
                    !x.price
                ) && (
                  <Col
                    lg={24}
                    className="d-flex align-items-center justify-content-end gap-2 mb-3"
                  >
                    {/* TODO: Tespit edilemeyenleri en üste koyma görevi */}

                    {/* <Button
                      type={
                        data.filter(
                          x =>
                            x.size === "" ||
                            x.style === "" ||
                            x.color === "" ||
                            x.price === "" ||
                            !x.price
                        ).length > 0
                          ? "dashed"
                          : ""
                      }
                      className={
                        data.filter(
                          x =>
                            x.size === "" ||
                            x.style === "" ||
                            x.color === "" ||
                            x.price === "" ||
                            !x.price
                        ).length > 0
                          ? "btn btn-danger"
                          : ""
                      }
                      onClick={() => handleFilterData()}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Eksik Verinin Sayfasını Göster (
                      {
                        data.filter(
                          x =>
                            x.size === "" ||
                            x.style === "" ||
                            x.color === "" ||
                            x.price === "" ||
                            !x.price
                        ).length
                      }
                      )
                    </Button> */}
                  </Col>
                )}
                {data.length > 0 && (
                  <>
                    <Col
                      lg={16}
                      className="d-flex align-items-center justify-content-start gap-2 mb-3"
                    >
                      <Row>
                        <Col lg={24}>
                          <Form
                            form={formV1}
                            style={{ width: "100%", maxWidth: 700 }}
                          >
                            <Form.Item
                              label="Record Name:"
                              name="saveNameFile"
                              rules={[
                                {
                                  required: true,
                                  message: "Kayıt Adı alanı zorunludur!",
                                },
                              ]}
                            >
                              <Space.Compact>
                                <Input
                                  style={{ width: "100%" }}
                                  disabled
                                  defaultValue={moment()
                                    .tz("America/Chicago")
                                    .format("DD-MM-YYYY")}
                                />
                              </Space.Compact>
                            </Form.Item>
                          </Form>
                        </Col>
                        {fileName?.length > 0 && (
                          <Col lg={24}>
                            <span
                              style={{ fontWeight: "bold", marginLeft: 10 }}
                            >
                              Record Name:
                            </span>{" "}
                            {fileName}
                          </Col>
                        )}
                      </Row>
                    </Col>
                    <Col
                      lg={8}
                      className="d-flex align-items-center justify-content-end gap-2 mb-3"
                    >
                      <Button
                        type={
                          data.filter(
                            x =>
                              x.size === "" ||
                              x.style === "" ||
                              x.color === "" ||
                              x.price === "" ||
                              !x.price
                          ).length > 0
                            ? "dashed"
                            : ""
                        }
                        className={
                          data.filter(
                            x =>
                              x.size === "" ||
                              x.style === "" ||
                              x.color === "" ||
                              x.price === "" ||
                              !x.price
                          ).length > 0
                            ? ""
                            : "btn btn-success"
                        }
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        disabled={saveButtonDisableCheck(data)}
                        onClick={() => {
                          setLoading(true)
                          handleSaveCsv()
                        }}
                        loading={loading}
                      >
                        Kaydet ({data.length})
                      </Button>
                    </Col>
                  </>
                )}
              </Row>
              <Row>
                {data.length === 0 && (
                  <Col lg={24} className="mb-2">
                    <div className="mb-3">
                      Bu alan, CSV dosyasını sürükle bırak veya tıklayarak
                      yüklemenizi sağlar.
                    </div>
                    <Form>
                      <Dropzone
                        onDrop={acceptedFiles => {
                          handleFileChange(acceptedFiles)
                        }}
                        multiple={false}
                        accept={{ "file/csv": [".csv"] }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone">
                            <div
                              className="dz-message needsclick mt-2"
                              {...getRootProps()}
                            >
                              <input type="file" {...getInputProps()} />
                              <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload " />
                              </div>
                              {file && file.name ? (
                                <h6 style={{ color: "red" }}>
                                  Upload File Name: {file.name}
                                </h6>
                              ) : (
                                <h4>
                                  Dosyayı buraya sürükleyin veya tıklayarak
                                  yükleyin.
                                </h4>
                              )}
                            </div>
                          </div>
                        )}
                      </Dropzone>
                      <Col
                        lg={24}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <Button
                          type="button"
                          className="btn btn-primary"
                          disabled={data.length > 0}
                          onClick={() => {
                            if (file && file.type === "text/csv") {
                              setLoading(true)

                              setShowDateModal(true)
                            } else {
                              toastr.error("Lütfen dosya yükleyiniz!")
                            }
                          }}
                          style={{
                            marginTop: 15,
                            height: 35,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                          }}
                        >
                          Parse
                        </Button>
                      </Col>
                    </Form>
                  </Col>
                )}
                {error && error.length > 2 && (
                  <Col lg={24}>
                    <h4 style={{ textAlign: "center", color: "red" }}>
                      {error}
                    </h4>
                  </Col>
                )}
                {data.filter(
                  x =>
                    x.size === "" ||
                    x.style === "" ||
                    x.color === "" ||
                    x.price === "" ||
                    !x.price
                ).length > 0 && (
                  <span style={{ color: "red" }}>
                    * Kayıt işlemi yapabilmek için lütfen tablodaki kırmızı
                    alanla işaretlenmiş verileri kontrol ediniz. Kontrol için
                    sağ üstteki butona bakınız.
                  </span>
                )}
                {data.length > 0 && (
                  <Col lg={24}>
                    <Form name="dynamic_form_item" form={form}>
                      <Form.List name="apparelList">
                        {() => (
                          <Table
                            bordered
                            size="small"
                            columns={tableColumns}
                            dataSource={data}
                            className="table table-centered"
                            scroll={{ x: 240 }}
                            pagination={{
                              total: data.length,
                              current: currentPage,
                              onChange: page => {
                                setPage(page)
                                form.setFieldsValue({ apparelList: data })
                              },
                            }}
                            rowKey="index"
                          />
                        )}
                      </Form.List>
                    </Form>
                  </Col>
                )}
                {notSaveList.length > 0 && (
                  <Col lg={24} style={{ color: "red" }}>
                    * {notSaveList.length} adet order eklenememiştir.{" "}
                    <span
                      style={{ color: "black", opacity: "0.7", marginLeft: 18 }}
                    >
                      Siparişin SKU, Sale Date veya Order numarası eksik
                      olabilir.
                    </span>
                    <br />* Eklenmeyen order numaraları:{" "}
                    <span style={{ color: "black", marginLeft: 8 }}>
                      {notSaveList.map((item, index) =>
                        index === notSaveList.length - 1
                          ? item.orderId
                          : item.orderId + ", "
                      )}
                    </span>
                  </Col>
                )}
              </Row>
            </Card>
          )}
        </Spin>
      </div>
    </React.Fragment>
  )
}

export default MultipleUploadFromShipStationCsv
